import React from 'react';
import PropTypes from 'prop-types';
import MainGridRowInfoDetailPachi from './MainGridRowInfoDetailPachi';
import MainGridRowInfoDetailSlot from './MainGridRowInfoDetailSlot';
import MainGridRowInfoSummaryPachi from './MainGridRowInfoSummaryPachi';
import MainGridRowInfoSummarySlot from './MainGridRowInfoSummarySlot';
import MainGridRowDetailPachi from './MainGridRowDetailPachi';
import MainGridRowDetailSlot from './MainGridRowDetailSlot';
import MainGridRowSummaryPachi from './MainGridRowSummaryPachi';
import MainGridRowSummarySlot from './MainGridRowSummarySlot';
import * as GridTitle from '../../../constants/K007/GridTitleMobile';
import * as commonLogic from '../../../logic/CommonLogic';

/**
 * MainGrid
 */
class MainGrid extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      detailGrid: null
    };
    this.handleDetailGridOpen = this.handleDetailGridOpen.bind(this);
    this.handleDetailGridClose = this.handleDetailGridClose.bind(this);
    this.createNodesSummary = this.createNodesSummary.bind(this);
    this.createNodesDetail = this.createNodesDetail.bind(this);
    this.isFilterFormModalOpen = false;
  }

  /**
   * グリッド詳細モーダル表示
   */
  handleDetailGridOpen(item, index) {
    const Nodes = this.createNodesDetail(item, index);
    this.setState({ detailGrid: Nodes });

    const mainPanel = $('#modal_detail_grid_panel');
    const contentBG = $('#modal_detail_grid_panel_bg');
    const panelContent = $('#modal_detail_grid_panel_content');

    const contentTop = $('#gird_data_area').offset().top;

    contentBG.css({
      top: contentTop,
      height: `calc(100% - ${contentTop + 70}px)`
    });

    mainPanel.show();
    contentBG.show();
    panelContent.show();
    commonLogic.switchPageTopIconState(false);

  }

  handleDetailGridClose() {
    $('#modal_detail_grid_panel').hide();
    $('#modal_detail_grid_panel_bg').hide();
    $('#modal_detail_grid_panel_content').hide();
    commonLogic.switchPageTopIconState(true);
  }

  /**
   * グリッドNode作成(概要)
   *
   * @param {*} targetDataList
   * @param {*} targetListKeys
   */
  createNodesSummary(targetDataList) {
    if (targetDataList) {
      let Nodes = targetDataList.map((item, index) => {
        let isNewIcon = false;
        if (item.newFlag == 1) {
          isNewIcon = true;
        }

        return (
          <div className="gird_data_content" onClick={() => this.handleDetailGridOpen(item, index)} data-index="index">
            <MainGridRowInfoSummaryPachi rowData={item} isNewIcon={isNewIcon} index={String(index + 1).padStart(4, '0')} />
            <MainGridRowSummaryPachi gridHeaderInfo={GridTitle.GRID_TITLE_PACHI_MOBILE_SUMMARY} gridData={item} />
          </div>
        );
      });
      if (this.props.data.rate > 2) {
        Nodes = targetDataList.map((item, index) => {
          let isNewIcon = false;
          if (item.newFlag == 1) {
            isNewIcon = true;
          }

          return (
            <div className="gird_data_content" onClick={() => this.handleDetailGridOpen(item, index)} data-index="index">
              <MainGridRowInfoSummarySlot rowData={item} isNewIcon={isNewIcon} index={String(index + 1).padStart(4, '0')} />
              <MainGridRowSummarySlot gridHeaderInfo={GridTitle.GRID_TITLE_SLOT_MOBILE_SUMMARY} gridData={item} />
            </div>
          );
        });
      }
      return Nodes;
    } else {
      return null;
    }
  }

  /**
   * グリッドNode作成(詳細)
   *
   * @param {*} targetData
   * @param {*} targetIndex
   */
  createNodesDetail(targetData, targetIndex) {
    let isNewIcon = false;
    if (targetData.newFlag == 1) {
      isNewIcon = true;
    }

    let Nodes = (
      <div className="gird_data_content_detail">
        <MainGridRowInfoDetailPachi rowData={targetData} isNewIcon={isNewIcon} index={String(targetIndex + 1).padStart(4, '0')} />
        <MainGridRowDetailPachi gridHeaderInfo={GridTitle.GRID_TITLE_PACHI_MOBILE} gridData={targetData} />
      </div>
    );

    if (this.props.data.rate >= 3) {
      Nodes = (
        <div className="gird_data_content_detail">
          <MainGridRowInfoDetailSlot rowData={targetData} isNewIcon={isNewIcon} index={String(targetIndex).padStart(4, '0')} />
          <MainGridRowDetailSlot gridHeaderInfo={GridTitle.GRID_TITLE_SLOT_MOBILE} gridData={targetData} />
        </div>
      );
    }

    return Nodes;
  }

  render() {
    let targetDataList = this.props.data.dataPachi;
    let targetListKeys = GridTitle.GRID_TITLE_PACHI_MOBILE_SUMMARY.map(item => item.key);
    if (this.props.data.rate >= 3) {
      targetDataList = this.props.data.dataSlot;
      targetListKeys = GridTitle.GRID_TITLE_SLOT_MOBILE_SUMMARY.map(item => item.key);
    }
    const Nodes = this.createNodesSummary(targetDataList, targetListKeys);

    return (
      <div className="content_fit">
        <div id="gird_data_area" className="gird_data_area" onScroll={e => this.props.actions.onScroll(e.target)}>
          {Nodes}

          {/* モーダル */}
          <div id="modal_detail_grid_panel" className="modal_detail_grid_panel" onClick={e => this.handleDetailGridClose(e)} />
          <div id="modal_detail_grid_panel_bg" className="modal_detail_grid_panel_bg" onClick={e => this.handleDetailGridClose(e)} />
          <div id="modal_detail_grid_panel_content" className="modal_detail_grid_panel_content" onClick={e => this.handleDetailGridClose(e)}>
            {this.state.detailGrid}
          </div>
        </div>
      </div>
    );
  }
}

MainGrid.propTypes = {
  data: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired
};

export default MainGrid;
